<template>
	<div class="contents6">
		<img class="bg" :src="bgImg" />
	</div>
</template>

<script>
export default {
	data() {
		return {
			bgImg: 'static/img/main-content/contents6.png',
			isMobile: false,
		}
	},
	mounted() {
		window.addEventListener('resize', this.resize)
		this.resize()
	},
	methods: {
		resize() {
			if (window.innerWidth > 640) {
				this.bgImg = 'static/img/main-content/contents6.png'
				this.isMobile = false
			} else {
				this.bgImg = 'static/img/mobile/main-content/contents6.png'
				this.isMobile = true
			}
		},
	},
}
</script>

<style scoped>
.contents6 {
	width: 100%;
	position: relative;
}
.contents6 .bg {
	width: 100%;
	height: auto;
	display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/Contents6.vue